import { IConnectivityService } from '../interfaces/IConnectivityService';

/**
 * Web Implementation of Connectivity Service
 * Uses browser's navigator.onLine and window online/offline events.
 */
export class WebConnectivityService implements IConnectivityService {
    async isOnline(): Promise<boolean> {
        return typeof navigator !== 'undefined' ? navigator.onLine : true;
    }

    subscribe(callback: (isOnline: boolean) => void): () => void {
        if (typeof window === 'undefined') return () => { };

        const handleOnline = () => callback(true);
        const handleOffline = () => callback(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }
}
